// Autogenerated file
export const tripSheetTechnicalInspectionResultsEnum = {
    NotCompleted: "NotCompleted",
    ReleaseAllowed: "ReleaseAllowed",
    ReleaseNotAllowed: "ReleaseNotAllowed",
    NotSpecified: "NotSpecified",
};
export const tripSheetTechnicalInspectionResults = [
    { label: "Контроль не завершён", value: "NotCompleted" },
    { label: "Выпуск разрешён", value: "ReleaseAllowed" },
    { label: "Выпуск не разрешён", value: "ReleaseNotAllowed" },
    { label: "Не указан", value: "NotSpecified" },
];
